/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .map[_ngcontent-%COMP%]{position:absolute;top:24px;left:24px;right:24px;bottom:24px;border-radius:3px;overflow:hidden;border:1px solid #d3d3d3}[_nghost-%COMP%]   .map[_ngcontent-%COMP%]   .google-map[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}@media screen and (max-width:774px){[_nghost-%COMP%]   .map[_ngcontent-%COMP%]{left:16px;right:16px;top:16px;bottom:16px}}"];
export { styles as styles };
